import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";

// // // //

export const ANNUAL_RETURN_TARGET_DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "annual_return_target_description",
    label: "Annual Return Target",
    type: ColumnTypes.string,
    width: 200,
    render: (item) => {
        if (!item.isAsset) return null;

        const value = item.annual_return_target_description;
        if (!value) return <Emdash />;

        return <span className="dg-overflow">{value}</span>;
    },
};
